import React, {useEffect, useState} from "react";
import {blankImage} from "../../ProductSeries/Image";

const defaultImage =
  "/media/gutscheine/Geschenkgutscheine/PatternInterruptionDefault.jpg";

/**
 * Pattern Interruption container
 * default is 'Geschenkgutschein'
 * will be alternated by exponea
 * @constructor
 */
const PatternInterruption: React.FC<{customClass?: string}> = ({customClass = ""}) => {
  const [src, setSrc] = useState<string>(blankImage);
  const [loadedClass, setLoadedClass] = useState<string | undefined>();

  useEffect(() => {
    setSrc(defaultImage);
  }, []);

  const onLoad = () => {
    setLoadedClass("img-loaded");
  };

  const onError = () => {
    setSrc(blankImage);
  };

  return (
    <div className={`pattern-interruption exponea-pattern-int ${customClass}`}>
      <div className="pattern-interruption__img exponea-pattern-int__image">
        <img
          alt="Verschenken, was wirklich gefällt &ndash; Gutscheine zum Ausdrucken für verschiedene Anlässe."
          src={src}
          onError={onError}
          onLoad={onLoad}
          className={loadedClass}
        />
      </div>
      <div className="pattern-interruption__content exponea-pattern-int__content">
        <h2 className="exponea-pattern-int__title">Connox Geschenkgutscheine</h2>
        <p className="exponea-pattern-int__text">
          Verschenken, was wirklich gefällt &ndash; Gutscheine zum Ausdrucken für verschiedene Anlässe.
        </p>
        <a
          className="cta-button cta-green m-0 exponea-pattern-int__button"
          href="https://www.connox.de/kategorien/geschenk-gutschein.html"
        >
          Jetzt entdecken
        </a>
      </div>
    </div>
  );
};

export default PatternInterruption;
